module.exports = __webpack_public_path__ + "6730bb2e4ece57ec6cab44ab3c98476b.png";